/* eslint-disable import/no-cycle */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */

import React, { Component, createRef } from "react";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import styles from "./FullScreenHomepageCartDropdown.module.css";
import brStyles from "./CartDropdownBrandRefresh.module.css";
import {
  formatCartOptionLine,
  getOrderCartItems,
  getRedeemableLoyaltyFields,
  hasOrderCartItems
} from "../../../Cart/cartDropdownHelpers";
import CartDropdownBrandRefreshUpsellCard from "./CartDropdownBrandRefreshUpsellCard";
import * as orderRepo from "../../../../shared/repos/graphql/order";
import * as orderActions from "../../../../redux/actions/order";
import { isCartOrder } from "../../../../shared/utilities/cartOrder";
import { getTotalPrice } from "../../../../shared/utilities/renderings";
import { orderMethods } from "../../../../shared/constants/order";
import {
  checkoutOrderMinAmount,
  getCartSubtotal,
  getLoyaltyDiscountAmount
} from "../../../../shared/utilities/orders";
import BrandRefreshButtonSpinner from "../../../BrandRefreshButtonSpinner/BrandRefreshButtonSpinner";
import { defaultCurrency } from "../../../../shared/constants/currency";
import endpoints from "../../../../shared/constants/endpoints";
import { routeCountryPath } from "../../../../shared/utilities/common";
import { PUNCHH_TYPE } from "../../../../shared/constants/loyaltyType";

const clearDarkIcon = require("../../../Cart/imgs/clear-dark-icon.svg");
const plusIcon = require("../../../Cart/imgs/dark-plus.svg");
const minusIcon = require("../../../Cart/imgs/dark-minus.svg");
const trashIcon = require("../../../Cart/imgs/trash.svg");
const alertWarningIcon = require("../../../Cart/imgs/alert-warning-circle.svg");
const alertCloseIcon = require("../../../Cart/imgs/alert-close.svg");
const upsellCaretRightIcon = require("../../../Cart/imgs/upsell-caret-right.svg");

export class FullScreenHomepageCartDropdown extends Component {
  constructor(props) {
    super(props);
    this.state = {
      orderLoading: false,
      errorMessage: null
    };
    this.dropdownRef = createRef();
  }

  componentDidMount() {
    document.addEventListener("mousedown", this.handleClickOutside);
    this.getOrder();
  }

  componentDidUpdate(prevProps) {
    const { order } = this.props;
    const { orderLoading } = this.state;
    if (prevProps.order !== order && !orderLoading) {
      this.getOrder();
    }
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside);
  }

  handleClickOutside = event => {
    const { toggleCartMenu } = this.props;
    if (event.target.closest("#cart-container")) {
      return;
    }
    if (
      this.dropdownRef.current &&
      !this.dropdownRef.current.contains(event.target)
    ) {
      toggleCartMenu(false);
    }
  };

  toggleDropdown = () => {
    const { toggleCartMenu } = this.props;
    toggleCartMenu();
  };

  getOrder = () => {
    const { userCartId, order } = this.props;
    if (!userCartId || order) return this.setOrder(order);
    return this.fetchOrder();
  };

  fetchOrder = async () => {
    const { userCartId } = this.props;
    try {
      this.setState({ orderLoading: true, errorMessage: null });
      const response = await orderRepo.getOrder(userCartId);
      this.setOrder(response.data.order);
    } catch (e) {
      this.setState({
        errorMessage: e.graphQLErrors?.[0]?.message || "Something went wrong!"
      });
    } finally {
      this.setState({ orderLoading: false });
    }
  };

  setOrder = order => {
    if (!order) return;
    const { orderUpdated } = this.props;
    this.setState({ orderLoading: false });
    orderUpdated(order);
  };

  getProductOptions = data => {
    if (!data.productOptions || data.productOptions.length === 0) {
      return [];
    }

    const result = [];
    data.productOptions.forEach(option => {
      const quantity = parseInt(option.quantity, 10);
      if (quantity && Number.isInteger(quantity) && quantity > 0) {
        const idx = result.findIndex(
          item => item.groupOptionId === option.groupOptionId.toString()
        );
        if (idx !== -1) {
          result[idx].productIds.push(
            ...Array(quantity).fill(option.options.id)
          );
        } else {
          result.push({
            groupOptionId: option.groupOptionId.toString(),
            productIds: Array(quantity).fill(option.options.id)
          });
        }
      }
    });

    return result;
  };

  updateQuantity = async (item, newQuantity) => {
    this.setState({ orderLoading: true, errorMessage: null });
    const { userCartId, order } = this.props;

    const orderRedeemable = order?.orderRedeemables?.find(
      p => p.order_product_id === item.id
    );

    const productOptions = this.getProductOptions(item);

    const { redemptionGroup, externalId } = getRedeemableLoyaltyFields(
      orderRedeemable
    );

    try {
      this.setState({ orderLoading: true, errorMessage: null });

      const action =
        newQuantity === 0
          ? orderRepo.removeProducts(userCartId, parseInt(item.id, 10))
          : orderRepo.addUpdateOrderProduct(userCartId, {
              orderProductId: parseInt(item.id, 10),
              product: item.product.id,
              productOptions,
              price: item.price,
              quantity: newQuantity,
              redeemableId:
                redemptionGroup === PUNCHH_TYPE.REDEEMABLE_FULL
                  ? externalId
                  : null,
              dealId: redemptionGroup === PUNCHH_TYPE.DEALS ? externalId : null
            });

      await action;
      this.fetchOrder();
    } catch (e) {
      this.setState({
        errorMessage: e.graphQLErrors?.[0]?.message || "Something went wrong!",
        orderLoading: false
      });
    }
  };

  goToCheckout = () => {
    const {
      history,
      userCartId,
      userOrderMethod,
      order,
      currency,
      toggleCartMenu
    } = this.props;
    const cartItems = getOrderCartItems(order);
    if (cartItems.length > 0) {
      if (userOrderMethod === orderMethods.delivery) {
        const cartIconLink = endpoints.checkoutOrderPage.replace(
          ":id",
          userCartId
        );
        const totalPrice = getCartSubtotal(cartItems);
        const loyaltyDiscountAmount = getLoyaltyDiscountAmount(order);
        if ((totalPrice - loyaltyDiscountAmount) < order.shippingMethodMinAmount) {
          checkoutOrderMinAmount(
            order.shippingMethodMinAmount,
            currency.symbol
          );
        } else {
          history.push(routeCountryPath(cartIconLink));
        }
      } else {
        history.push(
          routeCountryPath(
            endpoints.checkoutOrderPage.replace(":id", userCartId)
          )
        );
      }
      toggleCartMenu();
    }
  };

  goToPdpPage = item => {
    const { history, toggleCartMenu } = this.props;
    const { hasAssortments, options, id } = item;
    const isBox = hasAssortments;
    const isCustom = !isBox && options && options.length > 0;
    let path;
    if (isBox) {
      path = `/products/box/${id}`;
    } else if (isCustom) {
      path = `/products/customize/${id}`;
    } else {
      path = `/products/single/${id}`;
    }
    path += "?isUpsale=true";
    toggleCartMenu();
    return history.push(routeCountryPath(path));
  };

  renderErrorMessage() {
    const { errorMessage } = this.state;
    if (!errorMessage) {
      return null;
    }
    return (
      <div className={brStyles.errorAlert} role="alert">
        <span className={brStyles.errorAlertIcon} aria-hidden="true">
          <img src={alertWarningIcon} alt="" />
        </span>
        <p className={brStyles.errorAlertText}>{errorMessage}</p>
        <button
          type="button"
          className={brStyles.errorAlertClose}
          aria-label="Dismiss error"
          onClick={() => this.setState({ errorMessage: null })}
        >
          <img src={alertCloseIcon} alt="" />
        </button>
      </div>
    );
  }

  renderCartItems() {
    const { order } = this.props;
    if (!hasOrderCartItems(order)) {
      return <p className={brStyles.empty}>No items in your cart</p>;
    }
    return <ul className={brStyles.itemList}>{this.renderOrderItem(order)}</ul>;
  }

  renderOrderItem = order => {
    const cartItems = getOrderCartItems(order);
    if (cartItems.length === 0) return null;
    const { currency } = this.props;

    return cartItems.map(item => {
      if (!item.product) return null;

      const orderRedeemable = order.orderRedeemables?.find(
        p => p.order_product_id === item.id
      );
      const productOptionsPrice =
        item.productOptions?.reduce(
          (acc, option) => acc + (option.optionPrice * option.quantity || 0),
          0
        ) || 0;
      const amount = orderRedeemable
        ? item.price
        : getTotalPrice(item) * item.quantity - productOptionsPrice;

      return (
        <li key={item.id} className={brStyles.item}>
          <div className={brStyles.itemRow}>
            <div className={brStyles.itemImage}>
              <img
                src={item.product.productImageSmall}
                alt={item.product.title}
              />
            </div>
            <div className={brStyles.itemCopy}>
              <p className={brStyles.itemTitle}>{item.product.title}</p>
              <p className={brStyles.itemPrice}>
                {`${currency.symbol}${Number(amount).toFixed(2)}`}
              </p>
            </div>
            <div className={brStyles.qtyControl}>
              <button
                type="button"
                className={brStyles.qtyBtn}
                aria-label="Decrease quantity"
                onClick={() => this.updateQuantity(item, item.quantity - 1)}
              >
                <img
                  src={item.quantity > 1 ? minusIcon : trashIcon}
                  alt=""
                  aria-hidden="true"
                />
              </button>
              <span className={brStyles.qtyValue}>{item.quantity}</span>
              <button
                type="button"
                className={brStyles.qtyBtn}
                aria-label="Increase quantity"
                data-testid="add-item-button"
                onClick={() => this.updateQuantity(item, item.quantity + 1)}
              >
                <img src={plusIcon} alt="" aria-hidden="true" />
              </button>
            </div>
          </div>
          {item.productOptions?.length > 0 && (
            <ul className={brStyles.options}>
              {item.productOptions.map(option => (
                <li key={option.id} className={brStyles.optionLine}>
                  {formatCartOptionLine(option, currency)}
                </li>
              ))}
            </ul>
          )}
        </li>
      );
    });
  };

  renderUpSellProducts = () => {
    const { order, currency } = this.props;
    if (!order?.upsellProducts || order.upsellProducts.length === 0)
      return null;

    return (
      <div className={brStyles.upsellSection}>
        <h4 className={brStyles.upsellTitle}>Complement your cart</h4>
        <ul className={brStyles.upsellList}>
          {order.upsellProducts.slice(0, 3).map(item => (
            <CartDropdownBrandRefreshUpsellCard
              key={item.id}
              item={item}
              currencySymbol={currency.symbol}
              arrowIcon={upsellCaretRightIcon}
              onSelect={this.goToPdpPage}
            />
          ))}
        </ul>
      </div>
    );
  };

  renderCheckoutButton() {
    const { currency, order, userOrderMethod } = this.props;
    const cartItems = getOrderCartItems(order);
    const subTotal = getCartSubtotal(cartItems);
    const loyaltyDiscountAmount = getLoyaltyDiscountAmount(order);
    const minAmount = order?.shippingMethodMinAmount;
    const isMinAmountMatched =
      cartItems.length === 0 ||
      userOrderMethod !== orderMethods.delivery ||
      subTotal - loyaltyDiscountAmount >= minAmount;

    return (
      <button
        type="button"
        onClick={this.goToCheckout}
        tabIndex={0}
        onKeyDown={e => e.key === "Enter" && this.goToCheckout()}
        className={brStyles.checkoutBtn}
        disabled={!isMinAmountMatched}
      >
        {isMinAmountMatched
          ? "Checkout"
          : `${currency.symbol}${minAmount?.toFixed(2)} Delivery Minimum`}
      </button>
    );
  }

  renderSubTotal() {
    const { currency, order } = this.props;
    const cartItems = getOrderCartItems(order);
    const loyaltyDiscountAmount = getLoyaltyDiscountAmount(order);
    const subtotalDisplay = `${currency.symbol}${getCartSubtotal(cartItems).toFixed(
      2
    )}`;

    return (
      <>
        <div className={brStyles.subtotalRow}>
          <p className={brStyles.subtotalLabel}>Sub Total:</p>
          <p className={brStyles.subtotalValue}>{subtotalDisplay}</p>
        </div>
        {loyaltyDiscountAmount > 0 && (
          <div className={brStyles.rewardRow}>
            <p className={brStyles.rewardLabel}>Reward Redemption:</p>
            <p className={brStyles.rewardValue}>
              {`-${currency.symbol}${loyaltyDiscountAmount.toFixed(2)}`}
            </p>
          </div>
        )}
      </>
    );
  }

  renderScrollContent() {
    const { orderLoading } = this.state;
    const { order } = this.props;
    if (orderLoading) {
      return (
        <div className={brStyles.loaderWrap}>
          <BrandRefreshButtonSpinner size={40} />
        </div>
      );
    }
    return (
      <>
        {this.renderCartItems()}
        {hasOrderCartItems(order) && this.renderUpSellProducts()}
      </>
    );
  }

  render() {
    const { showCartMenu, toggleCartMenu, order } = this.props;
    if (!showCartMenu) {
      return null;
    }

    const { orderLoading } = this.state;
    const hasItems = hasOrderCartItems(order);

    return (
      <div
        id="cart-container"
        className={`${styles.cardDropdown} ${styles.brandRefresh} absolute text-dark zIndex`}
        ref={this.dropdownRef}
      >
        <div className={brStyles.panel} data-region="cart-dropdown">
          <div className={`${brStyles.header} ${styles.brandRefreshHeader}`}>
            <h4 className={brStyles.title}>Cart</h4>
            <button
              type="button"
              className={brStyles.closeBtn}
              aria-label="Close cart"
              onClick={toggleCartMenu}
            >
              <img src={clearDarkIcon} alt="" />
            </button>
          </div>
          {this.renderErrorMessage()}
          <div className={brStyles.scrollBody}>{this.renderScrollContent()}</div>
          {!orderLoading && hasItems && (
            <div className={brStyles.footer} data-region="cart-footer">
              {this.renderSubTotal()}
              {this.renderCheckoutButton()}
            </div>
          )}
        </div>
      </div>
    );
  }
}

FullScreenHomepageCartDropdown.propTypes = {
  currency: PropTypes.objectOf(PropTypes.string),
  userOrderMethod: PropTypes.string,
  userCartId: PropTypes.string,
  showCartMenu: PropTypes.bool,
  order: PropTypes.shape(),
  orderUpdated: PropTypes.func,
  toggleCartMenu: PropTypes.func,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired
  }).isRequired
};

FullScreenHomepageCartDropdown.defaultProps = {
  currency: defaultCurrency,
  userOrderMethod: null,
  userCartId: null,
  order: null,
  showCartMenu: false,
  orderUpdated: () => null,
  toggleCartMenu: () => null
};

export const mapStateToProps = ({ user, currency, order, elements }) => ({
  userCartId: user.userCartId,
  currency: currency.currency,
  userOrderMethod: user.userOrderMethod,
  showCartMenu: elements.showCartMenu,
  order: isCartOrder(order, user.userCartId) ? order : null
});

export const mapDispatchToProps = dispatch => ({
  orderUpdated: value => dispatch(orderActions.orderUpdated(value)),
  toggleCartMenu: value =>
    dispatch({ type: "TOGGLE_CART_MENU", payload: value })
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(FullScreenHomepageCartDropdown)
);
